"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hex2bytes = exports.bytes2hex = exports.bytes2Base64 = exports.string2bytes = void 0;
const text_encoder_1 = require("./text_encoder");
let $TextEncoder = (0, text_encoder_1.text_encoder)();
/**
 * Función auxiliar para convertir una cadena a su codificación utf-8, como un arreglo de bytes sin signo.
 *
 * @param input La cadena a convertir
 * @returns
 */
function string2bytes(input) {
    return $TextEncoder.encode(input);
}
exports.string2bytes = string2bytes;
/**
 * Función auxiliar para convertir una secuencia de bytes en su codificación base 64
 *
 * @param bytes Bytes por ser convertidos a base 64
 * @returns La cadena en base 64 resultante de los bytes
 */
function bytes2Base64(bytes) {
    let result = '', i, l = bytes.length;
    for (i = 2; i < l; i += 3) {
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[((bytes[i - 1] & 0x0F) << 2) | (bytes[i] >> 6)];
        result += base64abc[bytes[i] & 0x3F];
    }
    if (i === l + 1) { // 1 octet yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[(bytes[i - 2] & 0x03) << 4];
        result += "==";
    }
    if (i === l) { // 2 octets yet to write
        result += base64abc[bytes[i - 2] >> 2];
        result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
        result += base64abc[(bytes[i - 1] & 0x0F) << 2];
        result += "=";
    }
    return result;
}
exports.bytes2Base64 = bytes2Base64;
/**
 * Función auxiliar para convertir una secuencia de bytes en su codificación hexadecimal
 *
 * @param bytes Bytes por ser convertidos a base 64
 * @returns La cadena en base 64 resultante de los bytes
 */
function bytes2hex(bytes) {
    // Each byte turns into two characters
    let tokens = new Array();
    bytes.forEach((val, _) => {
        tokens.push(('00' + val.toString(16)).slice(-2));
    });
    return tokens.join('');
}
exports.bytes2hex = bytes2hex;
/**
 * Función auxiliar para decodificar una cadena hexadecimal a su valor en secuencia binaria
 *
 * @param hex Cadena codificada en hexadecimal
 * @returns bytes resulantes de la decodificación del hexadecimal proporcionado
 */
function hex2bytes(hex) {
    if ((hex.length % 2) !== 0) {
        throw new RangeError('Expected string to be an even number of characters');
    }
    // Now, we check that the string is a valid hex string
    for (var i = 0; i < hex.length; i++) {
        if (!(base16.has(hex.charAt(i)))) {
            throw new TypeError("String is not a valid hex string");
        }
    }
    // We create the buffer
    var view = new Uint8Array(hex.length / 2);
    // We fill it
    for (var i = 0; i < hex.length; i += 2) {
        view[i / 2] = parseInt(hex.substring(i, i + 2), 16);
    }
    return view;
}
exports.hex2bytes = hex2bytes;
// Literales de la base64 en orden
const base64abc = [
    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
    "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m",
    "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "/"
];
// Literales de la base hexadecimal en orden
const base16 = new Set([
    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"
]);
//# sourceMappingURL=conversion.js.map